import { filter, map } from "lodash";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography, Stack, Box } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SideNavLink from "components/base/SideNavLink";
import { setPulseCategoryId } from "context/features/dataSlice";
import { FeatureHelpVideo } from "features/Support";
import { useGetFeedCategories } from "../hooks/get-feed.hook";
import AccessibleIconButton from "components/base/AccessibleIconButton";
// import Joyride from "react-joyride";
// import JoyrideSoothTooltip from "components/base/JoyrideSoothTooltip";
// import useTour from "features/Tours/hooks/tour.hook";

export default function SideMenu() {
  // const { palette } = useTheme();
  const { feedCategories, breakCategories } = useGetFeedCategories();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const { isCategoriesSelected } = useSelector((state) => state.data);

  // const [steps] = useState([
  //   {
  //     target: "#your-pulse-title",
  //     title: "Welcome to Your Pulse!",
  //     content:
  //       "Pulse is your news aggregator to keep you up-to-date on the latest events. Your Pulse will show you the latest news and topics based on your topic preferences.",
  //     placement: "left",
  //     disableScrolling: true,
  //     data: {
  //       to: "/pulse",
  //     },
  //   },
  //   {
  //     target: "#pulse-news-article",
  //     title: "Latest News",
  //     content:
  //       "Pulse gives you quick access to the latest articles. As with Sooth's search features, all the research tools that Sooth's search gives you, including source details and bookmarking, are right at your fingertips.",
  //     disableScrolling: true,
  //   },
  //   {
  //     target: "#pulse-tour-category",
  //     title: "Choose a topic",
  //     content:
  //       "You can switch to and dive deeper on specific topics, too! Easily allowing you to see articles that might be just outside your normal topic preferences.",
  //     data: {
  //       to: "/pulse/label/US%20Politics",
  //     },
  //   },
  //   {
  //     target: "#pulse-preferences",
  //     title: "Pulse Preferences",
  //     content:
  //       "If you need to update which Topics you are interested in, you can find them in the Pulse preferences.",
  //     data: {
  //       to: "/pulse",
  //     },
  //   },
  //   {
  //     target: "#pulse-help",
  //     title: "Additional Help",
  //     content: "You can find additional help about how to use Pulse here.",
  //   },
  // ]);
  // const { runTour, stepIndex, handleTour } = useTour({
  //   tourId: "pulse",
  // });

  const handleLinkClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    navigate("/profile/preferences?id=pulse-category");
  };
  return (
    <Fragment>
      {/* {isCategoriesSelected && runTour && (
        <Joyride
          steps={steps}
          continuous
          run={isCategoriesSelected && runTour}
          initialStep={stepIndex}
          showProgress
          disableCloseOnEsc
          disableOverlayClose
          hideCloseButton
          showSkipButton
          callback={handleTour}
          styles={{
            options: {
              arrowColor:
                palette.mode === "dark" ? "#313131" : palette.background.paper,
              backgroundColor: palette.secondary.main,
              primaryColor: palette.primary.main,
              textColor: palette.text.primary,
            },
          }}
          tooltipComponent={JoyrideSoothTooltip}
        />
      )} */}
      <Stack direction="column" gap={1} sx={{ ml: 3, pt: 2 }}>
        <Typography variant="h6" color="#5c6d7e" fontStyle="italic" mt={1.3}>
          Topics{" "}
          <FeatureHelpVideo
            videoId="968264122"
            title="Tip: How do I use Pulse?"
            id="pulse-help"
          />
        </Typography>
        <Box>
          <SideNavLink
            style={{ display: "flex", justifyContent: "space-between" }}
            to="/pulse"
          >
            Your Pulse
            <AccessibleIconButton
              component="button"
              title="Edit Topic Preferences"
              onClick={handleLinkClick}
              id="pulse-preferences"
            >
              <MoreVertIcon />
            </AccessibleIconButton>
          </SideNavLink>
          {map(
            filter(feedCategories, (cat) => cat.categoryName !== "All"),
            (category, index) => {
              return (
                <SideNavLink
                  key={category.categoryId}
                  id={index === 0 ? "pulse-tour-category" : null}
                  onClick={() =>
                    dispatch(setPulseCategoryId(category.categoryId))
                  }
                  end={false}
                  to={`/pulse/label/${category.categoryName}`}
                >
                  {category.categoryName}
                </SideNavLink>
              );
            }
          )}
          {breakCategories && breakCategories.length > 0 && (
            <Fragment>
              <Typography
                variant="h6"
                color="#5c6d7e"
                fontStyle="italic"
                mt={1.3}
              >
                Breakout Topics{" "}
              </Typography>
              {breakCategories.map((category, index) => (
                <SideNavLink
                  key={category.categoryId}
                  onClick={() =>
                    dispatch(setPulseCategoryId(category.categoryId))
                  }
                  end={false}
                  to={`/pulse/breakout/${category.topicName}/${category.breakoutTopicId}`}
                >
                  {category.topicName}
                </SideNavLink>
              ))}
            </Fragment>
          )}
        </Box>
      </Stack>
    </Fragment>
  );
}
